
function buildAfterDrag(listeSrc, listeTgt, posSrc, posTgt, tuile){
	// console.log("buildAfterDrag: Déplacement de "+listeSrc+"["+posSrc+"] vers "+listeTgt+"["+posTgt+"]");
	var zoneSrc = "";
	var zoneTgt = "";
	/***
	* Identification de la zone d'origine
	*/
	if (listeSrc == "liste-service1") {
		if (posSrc < 4) {
			// La source est la zone A
			zoneSrc = "A";
		} else {
			// La source est la zone B
			zoneSrc = "B";
		}
	} else if (listeSrc == "liste-service2") {
		if (posSrc < 4) {
			// La source est la zone C
			zoneSrc = "C";
		} else {
			// La source est la zone D
			zoneSrc = "D";
		}
	}
	/***
	* Action en fonction de la zone cible (et celle d'origine définie précédemment)
	*/
	if (listeTgt == "liste-service1") {
		if (posTgt < 4) {
			// La cible est la zone A
			zoneTgt = "A";
			switch (zoneSrc) {
				case "B":
					/***
					- On retire d-none d-lg-block
					- on l'ajoute au 5ème élément
					- On supprime de C l'élément équivalent
					- Copier le 5ème élément de la liste 1 au début de la liste 2 en modifiant : "d-none d-lg-block col-lg-3" -> "col-sm-3 col-lg-2 d-lg-none"
					*/
					// console.log("de B vers A");
					tuile.removeClass("d-none d-lg-block");
					$("#liste-service1 div.draggable").eq(4).addClass("d-none d-lg-block");
					$("#liste-service2 div.draggable").eq(posSrc-4).remove();
					$("#liste-service1 div.draggable").eq(4).clone().removeClass("d-none d-lg-block col-lg-3").addClass("col-sm-3 col-lg-2 d-lg-none").insertAfter($("#liste-service2 div.draggable").eq(3));
					break;
				case "C":
					/***
					** On travaille ensuite sur le 5ème elt car on en ajoute un devant
					- Supprimer l'élément équivalent de la liste B
					- Copier le 5ème élément de la liste 1 au début de la liste 2 en modifiant : "d-none d-lg-block col-lg-3" -> "col-sm-3 col-lg-2 d-lg-none"
					- Ajouter au 5ème élément de la liste 1 "d-none d-lg-block"
					- Appliquer le changement suivant à l'élément déplacé : "col-sm-3 col-lg-2 d-lg-none" -> "col-lg-3"
					*/
					// console.log("de C vers A");
					$("#liste-service1 div.draggable").eq(5+posSrc).remove();
					$("#liste-service1 div.draggable").eq(4).clone().removeClass("d-none d-lg-block col-lg-3").addClass("col-sm-3 col-lg-2 d-lg-none").insertAfter($("#liste-service2 div.draggable").eq(3));
					$("#liste-service1 div.draggable").eq(4).addClass("d-none d-lg-block");
					tuile.removeClass("col-sm-3 col-lg-2 d-lg-none").addClass("col-lg-3");
					break;
				case "D":
					/***
					- Supprimer le dernier élément de la liste 1
					- Modifier le 4ème élément de la liste 2 : Retrait de "d-lg-none"
					- Copier le 5ème élément de la liste 1 au début de la liste 2 en modifiant : "col-lg-3" -> "col-sm-3 col-lg-2 d-lg-none"
					- Ajouter au 5ème élément (avant modif) de la liste 1 "d-none d-lg-block"
					- Appliquer le changement suivant à l'élément déplacé : "col-sm-3 col-lg-2" -> "col-lg-3"
					*/
					// console.log("de D vers A");
					$("#liste-service1 div.draggable").last().remove();
					$("#liste-service2 div.draggable").eq(3).removeClass("d-lg-none");
					$("#liste-service1 div.draggable").eq(4).clone().removeClass("col-lg-3").addClass("col-sm-3 col-lg-2 d-lg-none").insertAfter($("#liste-service2 div.draggable").eq(3));
					$("#liste-service1 div.draggable").eq(4).addClass("d-none d-lg-block");
					tuile.removeClass("col-sm-3 col-lg-2").addClass("col-lg-3");
					break;
				default:

			}
		} else {
			// La cible est la zone B
			zoneTgt = "B";
			switch (zoneSrc) {
				case "A":
					/***
					- on retire d-none d-lg-block au 4ème élément
					- On supprime le premier élément de liste 2
					- On copie l'objet déplacé à l'emplacement équivalent en zone C en appliquant les modifs css
					- On ajoute d-none d-lg-block
					*/
					$("#liste-service1 div.draggable").eq(3).removeClass("d-none d-lg-block");
					tuile.clone().removeClass("col-lg-3").addClass("col-sm-3 col-lg-2 d-lg-none").insertAfter($("#liste-service2 div.draggable").eq(posTgt-4));
					$("#liste-service2 div.draggable").first().remove();
					tuile.addClass("d-none d-lg-block");
					break;
				case "B":
					/***
					- Appliquer la même modif à l'objet de la zone C
					*/
					// Attention si on le déplace vers l'arrière, il n'est pas encore considéré comme déplacé, on doit ajouter 1 à l'index
					var posFinaleC = posTgt-4;
					if (posSrc < posTgt) posFinaleC +=1 ;
					$("#liste-service2 div.draggable").eq(posSrc-4).insertBefore($("#liste-service2 div.draggable").eq(posFinaleC));
					break;
				case "D":
					/***
					- Supprimer le dernier élément de la liste 1
					- Modifier le 4ème élément de la liste 2 : Retrait de "d-lg-none"
					- Copier l'élément déplacé en position (sa nouvelle position sur la liste 1 - 4) de la liste 2 en lui ajoutant "d-lg-none"
					- Appliquer le changement suivant à l'élément déplacé : "col-sm-3 col-lg-2" -> "col-lg-3 d-none d-lg-block"
					*/
					$("#liste-service1 div.draggable").last().remove();
					$("#liste-service2 div.draggable").eq(3).removeClass("d-lg-none");
					tuile.clone().addClass("d-lg-none").insertBefore($("#liste-service2 div.draggable").eq(posTgt-4));
					tuile.removeClass("col-sm-3 col-lg-2").addClass("col-lg-3 d-none d-lg-block");
					break;
				default:

			}
		}
	} else if (listeTgt == "liste-service2") {
		if ((posTgt < 4) || (posTgt == 4 && posSrc < 4)) {
			// La cible est la zone C
			zoneTgt = "C";
			switch (zoneSrc) {
				case "A":
					/***
					- Copier l'élément déplacé après l'élément en position (3 + sa nouvelle position) sur la liste 1 en lui ajoutant "d-none d-lg-block"
					- retirer "d-none d-lg-block" du 4ème élément de liste1
					- supprimer le premier élément de liste 2
					- Appliquer le changement suivant à l'élément déplacé : "col-lg-3" -> "col-sm-3 col-lg-2 d-lg-none"
					*/
					if (posTgt == 0) {
						// Cas spécial, on le déplace simplement à la fin de A
						tuile.insertAfter($("#liste-service1 div.draggable").eq(2));
					} else {
						tuile.clone().addClass("d-none d-lg-block").insertAfter($("#liste-service1 div.draggable").eq(posTgt+2));
						$("#liste-service1 div.draggable").eq(3).removeClass("d-none d-lg-block");
						$("#liste-service2 div.draggable").first().remove();
						tuile.removeClass("col-lg-3").addClass("col-sm-3 col-lg-2 d-lg-none");
					}
					break;
				case "C":
					/***
					- Appliquer la même modif à l'objet de la zone B
					*/
					var posFinaleC = posTgt+3;
					if (posSrc < posTgt) posFinaleC +=1 ;
					$("#liste-service1 div.draggable").eq(posSrc+4).insertAfter($("#liste-service1 div.draggable").eq(posFinaleC));
					break;
				case "D":
					/***
					- Copier l'élément déplacé après l'élément en position (3 + sa nouvelle position) sur la liste 1 en lui ajoutant "d-none d-lg-block col-lg-3" et en retirant col-sm3 col-lg2
					- Supprimer le dernier élément de liste 1
					- On ajoute d-lg-none
					- On retire d-lg-none au 5ème élément de liste2
					*/
					tuile.clone().addClass("d-none d-lg-block col-lg-3").removeClass("col-sm3 col-lg2").insertAfter($("#liste-service1 div.draggable").eq(posTgt+3));
					$("#liste-service1 div.draggable").last().remove();
					tuile.addClass("d-lg-none");
					$("#liste-service2 div.draggable").eq(4).removeClass("d-lg-none");
					break;
				default:

			}
		} else {
			// La cible est la zone D
			zoneTgt = "D";
			switch (zoneSrc) {
				case "A":
					/***
					- retirer "d-none d-lg-block" du 3ème élément de liste1
					- supprimer le premier élément de liste 2
					- Copier le 4ème élément de liste 2 à la fin de liste 1 en transformant "col-sm3 col-lg2" -> "col-lg-3 d-none d-lg-block"
					- Ajouter à ce 5ème élément "d-lg-none"
					- Appliquer le changement suivant à l'élément déplacé : "col-lg-3" -> "col-sm-3 col-lg-2"
					*/
					$("#liste-service1 div.draggable").eq(3).removeClass("d-none d-lg-block");
					$("#liste-service2 div.draggable").first().remove();
					$("#liste-service2 div.draggable").eq(3).clone().addClass("d-none d-lg-block col-lg-3").removeClass("col-sm3 col-lg2").insertAfter($("#liste-service1 div.draggable").last());
					$("#liste-service2 div.draggable").eq(3).addClass("d-lg-none");
					tuile.removeClass("col-lg-3").addClass("col-sm-3 col-lg-2");
					break;
				case "B":
					/***
					- Appliquer le changement suivant à l'élément déplacé : "d-none d-lg-block col-lg-3" -> "col-sm-3 col-lg-2"
					- Supprimer l'élément équivalent de la liste C
					- Copier le 4ème élément de liste 2 à la fin de liste 1 en transformant "col-sm3 col-lg2" -> "col-lg-3 d-none d-lg-block"
					- Ajouter à ce 4ème élément "d-lg-none"
					*/
					tuile.removeClass("d-none d-lg-block col-lg-3").addClass("col-sm-3 col-lg-2");
					$("#liste-service2 div.draggable").eq(posSrc-4).remove();
					$("#liste-service2 div.draggable").eq(3).clone().addClass("d-none d-lg-block col-lg-3").removeClass("col-sm3 col-lg2").insertAfter($("#liste-service1 div.draggable").last());
					$("#liste-service2 div.draggable").eq(3).addClass("d-lg-none");
					break;
				case "C":
					/***
					- On retire d-lg-none
					- Supprimer l'élément équivalent de la liste B
					- Copier le 4ème élément de liste 2 à la fin de liste 1 en transformant "col-sm3 col-lg2" -> "col-lg-3 d-none d-lg-block"
					- On ajoute d-lg-none au 4ème élément de liste2
					*/
					tuile.removeClass("d-lg-none");
					$("#liste-service1 div.draggable").eq(posSrc+4).remove();
					$("#liste-service2 div.draggable").eq(3).clone().addClass("d-none d-lg-block col-lg-3").removeClass("col-sm3 col-lg2").insertAfter($("#liste-service1 div.draggable").last());
					$("#liste-service2 div.draggable").eq(3).addClass("d-lg-none");
					break;
				default:

			}
		}
	}
	// console.log("buildAfterDrag: Déplacement de " + zoneSrc + " vers " + zoneTgt);
	// console.debug(tuile);
}

function sendFavOrder(indexTgt, indexSrc) {
	var favorisASvg = [];
	var tailleASvg = favArray.length;
	// console.log(tailleASvg+" "+indexTgt+" "+indexSrc);
	if ( tailleASvg < indexTgt) {
		// On recule un favori en dehors des favoris, on garde aussi les tuiles intermédiaires
		tailleASvg = indexTgt;
	} else if (indexSrc > tailleASvg) {
		// Un nouveau favori a été ajouté
		tailleASvg++;
	} else if (indexSrc == 0 && indexTgt == 0) {
		// On supprime un favori
		tailleASvg--;
	}
	//console.log("On sauvegarde les " + tailleASvg + " premiers favoris.");
	var increment = 1;
	$("#liste-service1 div.draggable").each(function( index ) {
		if (increment > tailleASvg) {
			// On stoppe l'itération
			return false;
		}
		favorisASvg.push( $( this ).find( $(".square-size-element")).attr("data-fname") );
		increment++;
	});

	$("#liste-service2 div.draggable").each(function( index ) {
		if (increment > tailleASvg) {
			// On stoppe l'itération
			return false;
		}
		var fname = $( this ).find( $(".square-size-element")).attr("data-fname");
		if (favorisASvg.indexOf(fname) < 0) {
			favorisASvg.push( fname );
			increment++;
		}
	});
	// console.log("On envoie les favoris : "+JSON.stringify(favorisASvg));

	sendFavs(favorisASvg);
	// set favorite level
	// $.ajax({
	// 	async:true,
	// 	dataType: "text",
	// 	url: "outils/user-pref.php",
	// 	type : 'GET',
	// 	data : 'favoris=' + JSON.stringify(favorisASvg),
	// 	success : function(){
	// 		//console.log("Préfs enregistées");
	// 		getFavorites();
	// 	},
	// 	error : function(resultat, statut, erreur){
	// 		// console.log("Une erreur s'est produite lors de l'enregistrement des favoris :"+resultat+",statut:"+statut+", erreur:"+erreur);
	// 	}
	// });
}

function sendFavs(favoris){
	$.ajax({
		async:true,
		dataType: "text",
		url: "outils/user-pref.php",
		type : 'GET',
		data : 'favoris=' + JSON.stringify(favoris),
		success : function(){
			//console.log("Préfs enregistées");
			getFavorites();
		},
		error : function(resultat, statut, erreur){
			// console.log("Une erreur s'est produite lors de l'enregistrement des favoris :"+resultat+",statut:"+statut+", erreur:"+erreur);
		}
	});
}

function dragndropActivate() {
	var hash = document.location.hash && decodeURIComponent(document.location.hash.replace(/^#/, ''));
	// On n'active que si on est sur la page d'accueil ou les favoris et si aucun filtrage n'est en cours
	if ((!hash || hash == "Tous" || hash == "Favoris") && (document.getElementById('defaultTab')) ){

		$( '#liste-service').find( $('div.card') ).each(function (index, elt) {

			var p = $(elt).parent( "div" )[0];
				$(p).addClass("draggable");
			// if($(p).attr('id') != 'esn-container') {
			// }
		});




		var posSrc = 0;
		var posTgt = 0;
		var listeSrc = "";
		var listeTgt = "";
		var aRetirer = false;



		$( "#liste-service1,#liste-service2" ).sortable({
			items: ".draggable",
			opacity: 0.5,
			tolerance: "pointer",
			// tolerance: "intersect",
			connectWith: "#liste-service1, #liste-service2",
			placeholder: "sortable-placeholder",
			zIndex: 9999,
			over: function() {
				//console.log("over");
				aRetirer = false;
			},
			out: function() {
				//console.log("out");
				aRetirer = true;
			},
			beforeStop: function( event, ui ) {
				// Élément déplacé en dehors, on annule l'action
				if (aRetirer === true) ui.item.data("canceled",true);
			},
			receive: function( event, ui ) {
				// Lors du déplacement dans une autre liste
				listeTgt = $(this).attr("id");
			},
			start: function( event, ui ) {
				//console.log("drag&drop start");

				// On interrompt l'action de clic sur l'élément déplacé (en plus de ce qui est fait dans l'action stop)
				$('.draggable').on("click",clickCancelonDrop);
				function clickCancelonDrop(event) {
					var cls = $(this).attr('class');
					// la classe ui-sortable-helper est ajoutée aux élèments en cours de déplacement
					if (cls.match('ui-sortable-helper'))
					return event.stopImmediatePropagation() || false;
				}

				ui.item.data("canceled", false);
				posSrc = ui.item.index();
				posTgt = ui.item.index();
				listeSrc = $(this).attr("id");
				listeTgt = $(this).attr("id");
				// Si la position vient de liste2, il faut retirer 1 à cause de ESN
				// if (listeSrc == "liste-service2") posSrc--;
			},
			stop: function( event, ui ) {
				//console.log("D&D stop");
				// On interrompt l'action de clic sur l'élément déplacé (en plus de ce qui est fait au dessus)
				$( event.toElement ).one('click', function(e){ e.stopImmediatePropagation(); } );

				if (ui.item.data("canceled")) {
					//console.log("Annuler tout");
					$(this).sortable("cancel");
				}
				posTgt = ui.item.index();
				// Si la position vient de liste2, il faut retirer 1 à cause de ESN
				// if (listeTgt == "liste-service2") posTgt--;

				// console.log("drag&drop stop: Déplacement de "+listeSrc+"["+posSrc+"] vers "+listeTgt+"["+posTgt+"]");
				// On n'enregistre que s'il y a eu déplacement
				if ((posSrc != posTgt || listeSrc != listeTgt) && (! ui.item.data("canceled"))) {
					buildAfterDrag(listeSrc, listeTgt, posSrc, posTgt, ui.item);

					// Enregistrement des modifications
					var realTgt = (listeTgt == "liste-service2") ? posTgt+4 : posTgt;
					var realSrc = (listeSrc == "liste-service2") ? posSrc+4 : posSrc;
					sendFavOrder(realTgt +1, realSrc +1);
				}
			}
		});

		function dragndropDisable() {
			// console.log("Désactivation drag & drop");
			$( "#liste-service1,#liste-service2" ).sortable( "disable" );
		}


	}

	$( "#liste-service .card-fav[data-level=2]" ).click(this, function() {
		if ( confirm("Vous allez supprimer la tuile \""+ $(this).prev().html().replace(/<[^>]*>/g,'') +"\" des favoris.\nVoulez-vous poursuivre votre action ?") ) {
			$("#liste-service .card-fav[data-fname="+$(this).attr("data-fname")+"]").parents(".draggable").remove();
			console.log("On va supprimer l'élément " + favArray.indexOf($(this).attr("data-fname"))+ " des favoris : "+favArray);
			const indexFavASupprimer = favArray.indexOf($(this).attr("data-fname"));
			favArray.splice(indexFavASupprimer,1);
			sendFavs(favArray);
			// sendFavOrder(0,0);
		}
		return false;
	});


	$( "#liste-service .card-fav[data-level=1]" ).click(this, function() {
		if ( confirm("Vous allez ajouter la tuile \""+ $(this).prev().html().replace(/<[^>]*>/g,'') +"\" aux favoris.\nVoulez-vous poursuivre votre action ?") ) {
			favArray.push($(this).attr("data-fname"));
			sendFavs(favArray);

			console.log("Ajout du favori " + $(this).attr("data-fname"));
			console.log("La liste des favoris devient " + favArray);
		}
		return false;
	});
}

function dragndropDisable() {
	// console.log("Désactivation drag & drop");
	// Fonction initialisée vide pour ne pas être appelée si le dragndrop n'est pas démarré
}

function dragndropEnable() {
	// console.log("Activation drag & drop");
	// Fonction initialisée vide pour ne pas être appelée si le dragndrop n'est pas démarré
}
